goog.provide("shadow.js.shim.module$src$svg$type$thumbnails$meta_carousel_svg$default");
shadow.js.shim.module$src$svg$type$thumbnails$meta_carousel_svg$default = shadow.js.shim.module$src$svg$type$thumbnails$meta_carousel_svg.default;
